"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var SummaryCard_1 = __importDefault(require("../SummaryCard"));
var overviewSlice_1 = require("../../state/overviewSlice");
function SummaryCardGroup() {
    var t = (0, react_i18next_1.useTranslation)().t;
    var data = (0, react_redux_1.useSelector)(overviewSlice_1.overviewReportSelector);
    var groupedData = (0, react_redux_1.useSelector)(overviewSlice_1.groupedDataOverviewSelector);
    var automationText = t('DASHBOARD.STATISTICS.AUTOMATION_LABEL');
    var manualText = t('DASHBOARD.STATISTICS.MANUAL_LABEL');
    var totalDecisionLabel = t('DASHBOARD.STATISTICS.TOTAL_DECISIONS_LABEL');
    var approvedLabel = t('DASHBOARD.STATISTICS.APPROVED_LABEL');
    var refusedLabel = t('DASHBOARD.STATISTICS.REFUSED_LABEL');
    var noDecisionLabel = t('DASHBOARD.STATISTICS.NO_DECISION_LABEL');
    var totalDecisions = groupedData.all.auto + groupedData.all.manual;
    var getCardData = function (key) {
        return {
            line1: {
                name: automationText,
                number: groupedData[key].auto,
                percentage: groupedData[key].auto / totalDecisions,
            },
            line2: {
                name: manualText,
                number: groupedData[key].manual,
                percentage: groupedData[key].manual / totalDecisions,
            },
        };
    };
    var totalDecisionCard = getCardData('all');
    var approvedCard = getCardData('accepted');
    var refusedCard = getCardData('rejected');
    var noDecisionCard = getCardData('noDecision');
    var getChartData = function (key) {
        return data.map(function (item, index) { return ({
            date: (0, date_fns_1.sub)(new Date(), { days: data.length - 1 - index }),
            close: item["".concat(key, "Auto")] + item["".concat(key, "Manual")],
        }); });
    };
    var approvedChartData = getChartData('accepted');
    var refusedChartData = getChartData('rejected');
    var noDecisionChartData = getChartData('noDecision');
    if (!groupedData || !data) {
        return react_1.default.createElement("div", null);
    }
    return (react_1.default.createElement("div", { className: "stat-cards-container" },
        react_1.default.createElement(SummaryCard_1.default, { name: "total-decision", className: "stat-summary-card--all", cardTitle: totalDecisionLabel, mainNumber: totalDecisions, line1: totalDecisionCard.line1, line2: totalDecisionCard.line2 }),
        react_1.default.createElement(SummaryCard_1.default, { name: "total-approved", className: "stat-summary-card--approved", cardTitle: approvedLabel, mainNumber: (groupedData.accepted.auto + groupedData.accepted.manual) / totalDecisions, showMainNumberAsPercentage: true, numberTopRight: groupedData.accepted.auto + groupedData.accepted.manual, line1: approvedCard.line1, line2: approvedCard.line2, lineChartData: approvedChartData }),
        react_1.default.createElement(SummaryCard_1.default, { name: "total-refused", className: "stat-summary-card--refused", cardTitle: refusedLabel, mainNumber: (groupedData.rejected.auto + groupedData.rejected.manual) / totalDecisions, showMainNumberAsPercentage: true, numberTopRight: groupedData.rejected.auto + groupedData.rejected.manual, line1: refusedCard.line1, line2: refusedCard.line2, lineChartData: refusedChartData }),
        react_1.default.createElement(SummaryCard_1.default, { name: "no-decision", className: "stat-summary-card--no-decision", cardTitle: noDecisionLabel, mainNumber: (groupedData.noDecision.auto + groupedData.noDecision.manual) / totalDecisions, showMainNumberAsPercentage: true, numberTopRight: groupedData.noDecision.auto + groupedData.noDecision.manual, line1: noDecisionCard.line1, line2: noDecisionCard.line2, lineChartData: noDecisionChartData })));
}
exports.default = SummaryCardGroup;
